export default __webpack_public_path__ + "static/media/home-book-fff.de4dc37e.jpg";